import React from 'react';
import { SocialLinks } from './SocialLinks';
export function Footer() {
  return <footer id="contact" className="bg-secondary text-white py-16" data-id="element-43">
      <div className="container-padding max-w-7xl mx-auto" data-id="element-44">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-45">
          <div data-id="element-46">
            <h2 className="text-3xl md:text-4xl font-display font-bold mb-6" data-id="element-47">
              Get In Touch
            </h2>
            <p className="text-gray-300 mb-8 max-w-md" data-id="element-48">
              I'm always open to discussing new projects, creative ideas, or
              opportunities to be part of your vision.
            </p>
            <div className="mb-8" data-id="element-49">
              <p className="text-gray-300 mb-2" data-id="element-50">
                <strong data-id="element-51">Email:</strong>{' '}
                <a href="mailto:akhisai2526@gmail.com" className="hover:text-primary transition-colors" data-id="element-52">
                  akhisai2526@gmail.com
                </a>{' '}
              </p>
            </div>
            <div className="mb-8" data-id="element-53">
              <p className="text-gray-300 mb-2" data-id="element-54">
                Bay Area, California
              </p>
              <div className="text-gray-300" data-id="element-55">
                <SocialLinks data-id="element-56" />
              </div>
            </div>
          </div>
          <div data-id="element-57">
            <h3 className="text-2xl font-display font-bold mb-6" data-id="element-58">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-59">
              <li data-id="element-60">
                <a href="#startups" className="text-gray-300 hover:text-primary transition-colors" data-id="element-61">
                  Startups
                </a>
              </li>
              <li data-id="element-62">
                <a href="#projects" className="text-gray-300 hover:text-primary transition-colors" data-id="element-63">
                  Projects
                </a>
              </li>
              <li data-id="element-64">
                <a href="#experience" className="text-gray-300 hover:text-primary transition-colors" data-id="element-65">
                  Experience
                </a>
              </li>
              <li data-id="element-66">
                <a href="#education" className="text-gray-300 hover:text-primary transition-colors" data-id="element-67">
                  Education
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-400" data-id="element-68">
          <p data-id="element-69">
            &copy; {new Date().getFullYear()} Sai Akhil Madurakavi. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}